/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
/* eslint-disable no-unused-vars*/
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar,
  Input,
  ModalProgressBar,
  Select
} from "../../../../_metronic/_partials/controls";

// import { OrganizationEditForm } from "./OrganizationEditForm";
import * as Yup from "yup";
import OrganizationEditForm from "./OrganizationEditForm";
import * as actions from "../../Organization/_redux/organization/organizationAction";
import * as reqDistrict from "../../MasterData/_redux/province/provinceCrud";
import EmailConfiguration from "./EmailConfiguration";
import LoadingAnimation from "../../Donatur/loading-animation/LoadingAnimation";
import { toast } from "react-toastify";
import { toastOption } from "../../../../_metronic/_helpers";

export const OrganizationEdit = ({
  history,
  match: {
    params: { id, parent_uuid, organization_type }
  }
}) => {
  const { organizations } = useSelector(
    state => ({ user: state.organizations }),
    shallowEqual
  );
  const [kotaValue, setKotaValue] = useState("");
  const [postalCode, setPostalCode] = useState([]);
  const [district, setDistrict] = useState([]);
  const [modal, setModal] = useState({
    emailConfiguration: false
  });

  const backToList = () => {
    history.push(`/organization`);
  };
  const backToParent = () => {
    history.push(`/organization/${parent_uuid}/edit`);
  };
  const openDetailDonationPage = id => {
    history.push(`/donasi/${id}/detail`);
  };
  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const [organizationProfile, setOrganizationProfile] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const cabangRole = [
    "SuperAdmin",
    "DataProses",
    "AdminCabang",
    "SuperDuperAdmin"
  ];
  const [showCabang, setShowCabang] = useState(false);
  const [branchList, setBranchList] = useState([]);

  const dispatch = useDispatch();

  let OrganizationEditSchema = (OrganizationEditSchema = Yup.object().shape({
    name: Yup.string().required("Nama wajb diisi"),
    domain_name: Yup.string().required("Domain wajb diisi")
  }));

  const onInputChange = e => {
    const value = e.target.value;

    if (value.length >= 3) {
      let query = {
        district: value,
        city: value
      };
      reqDistrict.findDistrict(query).then(response => {
        setDistrict(response.data.data);
      });
    }
  };

  const { actionsLoading, organizationForEdit, error, isLetter } = useSelector(
    state => ({
      actionsLoading: state.organizations.actionsLoading,
      organizationForEdit: state.organizations.organizationForEdit,
      isLetter: state.organizations.is_letter,
      error: state.organizations.error
    }),
    shallowEqual
  );

  useEffect(() => {
    let _title = id ? "" : "Organization";
    setTitle(_title);

    if (organizationForEdit) {
      setKotaValue(
        `${
          organizationForEdit.district ? organizationForEdit.district + "," : ""
        } ${organizationForEdit.city + ","} ${organizationForEdit.province}`
      );
      setPostalCode([organizationForEdit.postal_code]);
    }
  }, [organizationForEdit, id]);

  useEffect(() => {
    dispatch(actions.fetchOrganization());
  }, [id]);

  const onSelectTag = (value, setFieldValue) => {
    const array = value.split(",");
    if (array.length === 3) {
      let index = district.findIndex(
        i =>
          i.district === array[0].trim() &&
          i.city === array[1].trim() &&
          i.province_name === array[2].trim()
      );
      setPostalCode(district[index].postalcode);
      setFieldValue("province", district[index].province_name);
      setFieldValue("city", district[index].city);
      setFieldValue("district", district[index].district);
      setKotaValue(
        `${district[index].district}, ${district[index].city}, ${district[index].province_name}`
      );
    }
  };

  const btnRef = useRef();

  let initialValues = {
    name: "",
    domain_name: "",
    call_center: "",
    whatsapp: "",
    instagram: "",
    twitter: "",
    facebook: "",
    postal_code: "",
    city: "",
    email: "",
    name_sender: ""
  };

  const updateOrganization = async value => {
    const formData = new FormData();
    formData.append("name", value.name);
    formData.append("domain_name", value.domain_name);
    formData.append("call_center", value.call_center);
    formData.append("whatsapp", value.whatsapp);
    formData.append("instagram", value.instagram);
    formData.append("twitter", value.twitter);
    formData.append("facebook", value.facebook);
    formData.append("postal_code", value.postal_code);
    formData.append("city", value.city);
    formData.append("district", value.district);
    formData.append("name_sender", value.name_sender);
    formData.append("name_sender", value.name_sender);
    formData.append("file", value.file);
    formData.append("province", value.province);
    formData.append("address", value.address);
    formData.append("delete_image", value.delete_image);
    formData.append("longitude", value.longitude);
    formData.append("latitude", value.latitude);
    formData.append("bank_name", value.bank_name);
    formData.append("bank_account", value.bank_account);
    formData.append("bank_account_behalf", value.bank_account_behalf);

    dispatch(actions.updateOrganization(formData)).then(() => {
      window.location.reload(true);
    });
    // console.log(formData);
    for (var pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }
  };

  const onSubmitEmailConfiguration = value => {
    if (value.is_test_email) {
      dispatch(actions.orgTestEmailConfiguration(value)).then(res => {
        if (res.error) {
          toast.error(res.message);
        } else {
          toast.success(res.message);
        }
        dispatch(actions.fetchOrganization());
        // setModal(prev => ({ ...prev, emailConfiguration: false }));
      });
    } else {
      dispatch(actions.updateEmailConfiguration(value)).then(res => {
        toast.success(res.message, toastOption);
        dispatch(actions.fetchOrganization());
        setModal(prev => ({ ...prev, emailConfiguration: false }));
      });
    }
  };

  const initialEmailConfig = {
    email_host: organizationForEdit.email_host,
    email_port: organizationForEdit.email_port,
    email_secure: organizationForEdit.email_secure
      ? organizationForEdit.email_secure
      : false,
    email_user: organizationForEdit.email_user,
    email_pass: organizationForEdit.email_pass,
    email_from: organizationForEdit.email_from,
    email_tls: organizationForEdit.email_tls
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <EmailConfiguration
        show={modal.emailConfiguration}
        onHide={() =>
          setModal(prev => ({ ...prev, emailConfiguration: false }))
        }
        onSubmit={onSubmitEmailConfiguration}
        initialValues={initialEmailConfig}
      />
      {/*<ToastContainer/>*/}
      <Card>
        <CardHeader title={title}>
          <CardHeaderToolbar>
            <button
              className="btn btn-primary"
              onClick={() =>
                setModal(prev => ({ ...prev, emailConfiguration: true }))
              }
            >
              Konfigurasi Kirim Email
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <br></br>

        <OrganizationEditForm
          organization={organizationForEdit || {}}
          saveOrganization={updateOrganization}
        />
      </Card>
    </>
  );
};
